module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Strikethrough-d9635f696284cbe7207a5953f3ad18b1.svg";